import React, { forwardRef } from 'react';
import { DefaultProps } from '@mantine/styles';

export interface TabProps extends DefaultProps, React.ComponentPropsWithoutRef<'button'> {
  /** Tab control label */
  label?: React.ReactNode;

  /** Icon on the left side of label */
  icon?: React.ReactNode;

  /** Tab content */
  children?: React.ReactNode;

  /** Get tab control ref */
  ref?: React.ForwardedRef<HTMLButtonElement>;
}

export interface TabType {
  type: any;
  props: TabProps;
  ref: React.ForwardedRef<HTMLButtonElement>;
}

type TabComponent = (props: TabProps) => React.ReactElement;

export const Tab: TabComponent & { displayName?: string } = forwardRef<HTMLButtonElement, TabProps>(
  () => null
);

Tab.displayName = '@mantine/core/Tab';
